<script setup lang="ts">
import { useTurnstile } from '@pkg/form-builder/web/composables/useTurnstile';
import { onMounted, ref, watch } from 'vue';
import { logger } from '@pkg/logger';
import type { TurnstileStatusValue } from '@pkg/form-builder/types';

const { public: { cloudFlare } } = useRuntimeConfig();

const emit = defineEmits<{
  statusChange: [status: TurnstileStatusValue, token: string | null];
}>();

const turnstileContainer = ref<HTMLElement | null>(null);
const { status, error, token, render, restart } = useTurnstile(cloudFlare?.siteKey ?? '', turnstileContainer);

watch([status, token], ([newStatus, newToken]) => {
  emit('statusChange', newStatus as TurnstileStatusValue, newToken);
}, { immediate: true });

const resetTurnstile = () => {
  try {
    restart();
  } catch (e) {
    logger.info('Error resetting turnstile', e);
  }
};

// Render the widget when the component is mounted
onMounted(() => {
  render();
});
</script>

<template>
  <div ref="turnstileContainer" class="mb-16">
    <div v-if="status === 'loading'">
      <small class="text-gray-500">
        Loading token...
      </small>
    </div>
    <div v-if="status === 'error'">
      <p><small class="text-gray-500">{{ error }}</small></p>
      <button @click="resetTurnstile">
        <small class="text-gray-500">
          Refresh
        </small>
      </button>
    </div>
  </div>
</template>
